import { render, staticRenderFns } from "./ag_test_suite_panel.vue?vue&type=template&id=ad272e70&scoped=true&"
import script from "./ag_test_suite_panel.vue?vue&type=script&lang=ts&"
export * from "./ag_test_suite_panel.vue?vue&type=script&lang=ts&"
import style0 from "./ag_test_suite_panel.vue?vue&type=style&index=0&id=ad272e70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad272e70",
  null
  
)

export default component.exports